module.exports = __webpack_public_path__ + "img/home-preview-en.285efd13.png";